export { default } from './ProductImage';
